// from https://github.com/ryanwiemer/rw/issues/1#issuecomment-361003862
// is fixed in Gatsby v2, this can be removed if upgraded

exports.onRouteUpdate = args => {
  if (typeof window !== "undefined" && args.action === "PUSH") {
    window.scrollTo(0, 0);
  }
};

exports.shouldUpdateScroll = args => Boolean(args.prevRouterProps === null ||
    (args.prevRouterProps && args.prevRouterProps.history.action === "POP"));



// WEBPACK FOOTER //
// ./gatsby-browser.js